// extracted by mini-css-extract-plugin
module.exports = {"tagPill":"TagPill_tagPill__v7VrG","navigationPill":"TagPill_navigationPill__peVRH","generalAccent":"TagPill_generalAccent__lIdMP","onDark":"TagPill_onDark__hFbDt"};